// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"581":"ec9180d6","787":"63d065ce","829":"92914253","878":"ad15306d","913":"22e5c0ce"}[chunkId] + ".chunk.js";
};